import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { ModalContainer } from '../../../../shared/modal-container/ModalContainer';
import TransparentButton from '../../../../shared/button/transparent-button/TransparentButton';
import { BlueContainedButton } from '../../../../shared/button/blue-contained-button/BlueContainedButton';

/*
  Asks to confirm something before it is done. Open it with `open()` on a ref, after the state that `message` and `onConfirm`
  are made from has been set.
*/
export class ConfirmModal extends Component {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.node,
        confirmText: PropTypes.string,
        onConfirm: PropTypes.func
    };

    modalRef = React.createRef();

    open = () => this.modalRef.current && this.modalRef.current.openModal();

    close = () => this.modalRef.current && this.modalRef.current.closeModal();

    confirm = () => {
        const { onConfirm } = this.props;

        this.close();
        onConfirm && onConfirm();
    };

    render() {
        const { title, message, confirmText } = this.props;

        return (
            <ModalContainer
                ref={this.modalRef}
                title={title}
                content={
                    <div className={'sim-confirm-modal'}>
                        <div className={'sim-confirm-message'}>{message}</div>
                        <div className={'row modal-actions'}>
                            <TransparentButton onClick={this.close}>
                                Cancel
                            </TransparentButton>
                            <BlueContainedButton
                                text={confirmText || 'Confirm'}
                                onClick={this.confirm}
                            />
                        </div>
                    </div>
                }
            />
        );
    }
}
